module.exports = __webpack_public_path__ + "img/c5c3d7b421805988040c1a6cc90cd061.png";